var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoIcon = function SvgLogoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EBE9F7",
    d: "M16.581 12c0-3.503-1.675-5.064-3.19-5.885-1.77-.96-3.978-.936-7.144-.936H2.4c-1.131 0-1.697 0-2.049-.351C0 4.476 0 3.91 0 2.779V1.376c0-.647 0-.97.2-1.17C.403.003.726.003 1.372.003h4.876c2.648 0 6.535-.17 9.82 1.611C19.037 3.225 22 6.385 22 12s-2.964 8.775-5.932 10.385c-3.286 1.782-7.173 1.61-9.82 1.61H1.37c-.646 0-.97 0-1.17-.2C0 23.594 0 23.27 0 22.625V21.22c0-1.131 0-1.697.351-2.049.352-.351.918-.351 2.049-.351h3.847c3.166 0 5.375.024 7.144-.936 1.515-.821 3.19-2.382 3.19-5.885"
  })));
};
export default SvgLogoIcon;